const initProductColorsWidget = () => {
    const colorPickerElementsArray = document.querySelectorAll("[data-color-picker-element]");
    const productColorElementsArray = document.querySelectorAll("[data-product-color-component]");
    const backGroundImagesArray = document.querySelectorAll("[data-background-image]");
    colorPickerElementsArray && colorPickerElementsArray.forEach((element) => {
        element.addEventListener("click", () => {
            if (!element.classList.contains("active")) {
                const selectedColor = element.getAttribute("data-color-picker-element");
                //1. COLOR PICKER
                //remove class active for all elements
                colorPickerElementsArray.forEach((notClickedElement) => notClickedElement.classList.remove("active"));
                ///set clicked element as active
                element.classList.add("active");
                //2. PRODUCT COLOR COMPONENT
                const selectedProductColor = document.querySelector(`[data-product-color-component="${selectedColor}"]`);
                productColorElementsArray && productColorElementsArray.forEach((notSelectedElement) => {
                    //add class "was-active" to the previous color
                    notSelectedElement.classList.contains("active") ? notSelectedElement.classList.add("was-active") : null;
                    //remove class active from all other active elements
                    notSelectedElement.classList.remove("active");
                });
                //set selected product as active
                selectedProductColor.classList.add("active");
                //3. BACKGROUND
                const selectedBackgroundImage = document.querySelector(`[data-background-image="${selectedColor}"]`);
                //remove class active for all elements
                backGroundImagesArray && backGroundImagesArray.forEach((notSelectedImage) => {
                    //add class "was-active" to the previous background
                    notSelectedImage.classList.contains("active") ? notSelectedImage.classList.add("was-active") : null;
                    //remove class active from all other active elements
                    notSelectedImage.classList.remove("active");
                });
                //set selected product as active
                selectedBackgroundImage.classList.add("active");
                //when element is set, remove "was active" class
                setTimeout(() => {
                    const wasActiveElementsList = document.querySelectorAll(".was-active");
                    wasActiveElementsList.forEach((wasActiveElement) => {
                        wasActiveElement.classList.remove("was-active");
                    });
                }, 1000);
            }
        });
    });
};
